import React, { useState } from 'react';

import { resolveArguments } from 'helpers/utils';

import { PromoCountrySearchBar } from './PromoCountrySearchBar';
import { PromoEmptyPage } from './PromoEmptyPage';
import PromoFullCountryList from './PromoFullCountryList';
import { LightNavBar } from '../../common/fromAuth/LightNavBar/LightNavBar';
import PromoModalComponent from '../../utils/PromoModalComponent';

export const PromoFullViewCountrySearch = (props) => {
    const [countryList, setCountryList] = useState({
        countryList: props.countries,
        query: '',
    });

    return (
        <PromoModalComponent canCloseModal={false} isVerticalCentered={countryList.countryList.length === 0}>
            {countryList.countryList.length > 0 ? (
                <PromoFullCountryList
                    countries={countryList.countryList}
                    onCountryItemClick={props.onCountryItemClick}
                    iso2={props.iso2}
                    query={countryList.query}
                />
            ) : (
                <PromoEmptyPage notFoundMessage={resolveArguments(props.searchNoResult, countryList.query)} />
            )}
            <LightNavBar isSearchBar>
                <PromoCountrySearchBar
                    setCountryList={setCountryList}
                    toggleSearch={props.toggleSearch}
                    countries={props.countries}
                    placeholder={props.placeholder}
                />
            </LightNavBar>
        </PromoModalComponent>
    );
};
